import loadAndInitThree from 'src/scripts/loadAndInitThree';

const fiftyFifty = (): void => {
  const selectors = {
    fiftyFiftySection: '[data-fifty-fifty]',
    hoverEffectVideo: '[data-hover-effect-video]',
    hoverEffectToggle: '[data-hover-effect-video-toggle]',
    threeDContainer: '[data-3d-container]',
    threeDContainerObject: 'data-3d-object',
  };

  const fiftyFiftySections = document.querySelectorAll(
    selectors.fiftyFiftySection
  );

  const ioSupported = 'IntersectionObserver' in window;
  const observer = ioSupported
    ? new IntersectionObserver(
        (entries, io) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const el = entry.target as HTMLElement;
            const objectName =
              el.getAttribute(selectors.threeDContainerObject) || '';
            loadAndInitThree(el, objectName);
            io.unobserve(el); // run once
          });
        },
        {
          // Preload a bit before it’s actually on screen
          root: null,
          rootMargin: '200px 0px',
          threshold: 0.15, // ~15% visible
        }
      )
    : null;

  fiftyFiftySections.forEach((section) => {
    // Video
    // let isDragging = false;

    const hoverEffectVideoToggle = section.querySelector(
      selectors.hoverEffectToggle
    );
    const hoverEffectVideo = section.querySelector<HTMLVideoElement>(
      selectors.hoverEffectVideo
    );

    if (hoverEffectVideo && hoverEffectVideoToggle) {
      // Hovering
      // hoverEffectVideo.addEventListener('mousemove', (e) => {
      //   if (isDragging) return;
      //   if (window.innerWidth <= 992) return;
      //   const rect = hoverEffectVideo.getBoundingClientRect();
      //   const offsetX = e.clientX - rect.left;
      //   const percentX = (offsetX / rect.width) * 100;
      //   const clampedPercent = Math.min(100, Math.max(0, percentX));
      //   hoverEffectVideo.parentElement?.style.setProperty(
      //     '--position-x',
      //     `${clampedPercent}%`
      //   );
      //   const videoDuration = hoverEffectVideo.duration;
      //   const currentTime = (clampedPercent / 100) * videoDuration;
      //   hoverEffectVideo.currentTime = currentTime;
      // });
      // Dragging
      // const onMouseMove = (e: MouseEvent): void => {
      //   const rect = hoverEffectVideo.getBoundingClientRect();
      //   const offsetY = e.clientY - rect.top;
      //   const percentY = (offsetY / rect.height) * 100;
      //   const clampedPercent = Math.min(100, Math.max(0, percentY));
      //   hoverEffectVideo.parentElement?.style.setProperty(
      //     '--position-x',
      //     `${100 - clampedPercent}%`
      //   );
      //   const videoDuration = hoverEffectVideo.duration;
      //   const currentTime = (clampedPercent / 100) * videoDuration;
      //   hoverEffectVideo.currentTime = currentTime;
      // };
      // const onMouseUp = (): void => {
      //   isDragging = false;
      //   document.removeEventListener('mousemove', onMouseMove);
      //   document.removeEventListener('mouseup', onMouseUp);
      // };
      // hoverEffectVideoToggle.addEventListener('mousedown', (e) => {
      //   isDragging = true;
      //   e.preventDefault();
      //   document.addEventListener('mousemove', onMouseMove);
      //   document.addEventListener('mouseup', onMouseUp);
      // });

      const video = hoverEffectVideo as HTMLVideoElement;
      const handle = hoverEffectVideoToggle as HTMLElement;

      let isDragging = false;
      let rafId: number | null = null;

      const clamp01 = (v: number) => Math.min(1, Math.max(0, v));
      const setPosFromPercent = (p: number) => {
        const percent = p * 100;
        video.parentElement?.style.setProperty(
          '--position-x',
          `${100 - percent}%`
        );
      };

      const percentFromClientY = (clientY: number) => {
        const rect = video.getBoundingClientRect();
        const offsetY = clientY - rect.top;
        return clamp01(offsetY / rect.height);
      };

      const onPointerMove = (e: PointerEvent) => {
        if (!isDragging) return;
        const p = percentFromClientY(e.clientY);
        setPosFromPercent(p);
        if (Number.isFinite(video.duration) && video.duration > 0) {
          video.currentTime = p * video.duration;
        }
      };

      const endDrag = () => {
        isDragging = false;
        window.removeEventListener('pointermove', onPointerMove);
        window.removeEventListener('pointerup', endDrag);
        window.removeEventListener('pointercancel', endDrag);
      };

      handle.addEventListener('pointerdown', (e) => {
        e.preventDefault();
        handle.setPointerCapture?.(e.pointerId);
        isDragging = true;
        window.addEventListener('pointermove', onPointerMove);
        window.addEventListener('pointerup', endDrag, { once: true });
        window.addEventListener('pointercancel', endDrag, { once: true });
      });

      const tick = () => {
        if (
          !isDragging &&
          Number.isFinite(video.duration) &&
          video.duration > 0
        ) {
          const p = video.currentTime / video.duration;
          setPosFromPercent(clamp01(p));
        }
        rafId = requestAnimationFrame(tick);
      };

      const startLoop = () => {
        if (rafId == null) rafId = requestAnimationFrame(tick);
      };
      const stopLoop = () => {
        if (rafId != null) cancelAnimationFrame(rafId);
        rafId = null;
      };

      video.addEventListener('play', startLoop);
      video.addEventListener('pause', stopLoop);
      video.addEventListener('ended', stopLoop);

      video.addEventListener('loadedmetadata', () => {
        setPosFromPercent(0);
        if (!video.paused) startLoop();
      });

      if (!video.paused) startLoop();
    }

    // 3D
    const threeDContainer = section.querySelector<HTMLElement>(
      selectors.threeDContainer
    );
    if (threeDContainer) {
      const objectName =
        threeDContainer.getAttribute(selectors.threeDContainerObject) || '';
      if (observer) {
        observer.observe(threeDContainer);
      } else {
        void loadAndInitThree(threeDContainer, objectName);
      }
    }
  });
};

export default fiftyFifty;
